<template>
    <a class="ui-link" @click="$emit('click')"><slot></slot></a>
</template>

<script>
    export default {
        name: 'ui-link',
        props: ['onClick'],
    };
</script>

<style>
    a.ui-link {
        color: #2b75bb;
        cursor: pointer;
    }

    a.ui-link:hover {
        opacity: .9;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// UiLink.vue?10410398